import React, { forwardRef } from 'react';

const formatPhoneNumber = (value) => {
  // Remove all non-digit characters
  const cleaned = ('' + value).replace(/\D/g, '');

  // Match the cleaned value with a pattern
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

  if (match) {
    const [, areaCode, middle, last] = match;

    // Build the formatted number
    let formatted = '';
    if (areaCode) {
      formatted += `(${areaCode}`;
    }
    if (areaCode && middle) {
      formatted += `) ${middle}`;
    }
    if (areaCode && middle && last) {
      formatted += `-${last}`;
    }

    return formatted;
  }

  return value;
};

// Use forwardRef to properly handle refs from react-hook-form
const PhoneInput = forwardRef(({ label, name, error, ...rest }, ref) => {
  const handleKeyDown = (e) => {
    // Allow control keys like backspace, delete, arrow keys
    if (
      e.key !== 'Backspace' &&
      e.key !== 'Delete' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowRight' &&
      !/[0-9]/.test(e.key)
    ) {
      e.preventDefault();
    }
  };

  return (
    <div className="mb-4">
      <label htmlFor={name} className="pb-1 text-lg font-semibold">
        {label}
      </label>
      <input
        type="text"
        id={name}
        name={name}
        inputMode="numeric"
        onKeyDown={handleKeyDown}
        maxLength={10} // Enforce a maximum length of 10 characters
        className={`mt-1 block w-full px-3 py-2 border ${
          error ? 'border-red-500' : 'border-gray-300'
        } rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`}
        ref={ref} // Forward the ref to allow react-hook-form to control this input
        {...rest}
      />
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
});
export default PhoneInput;
